import { TMdfBreakdownGroupField } from '../../../model/types'

export interface IGroupFieldOption {
  value: TMdfBreakdownGroupField
  labelKey: string
}

export const getGroupFieldOptions = (): IGroupFieldOption[] => [
  {
    value: 'strategicInitiatives',
    labelKey: 'Strategic Initiative',
    // labelKey: KEYS.category,
  },
  {
    value: 'businessPriorities',
    labelKey: 'Business Priority',
    // labelKey: KEYS.businessPriority,
  },
  {
    value: 'businessUnit',
    labelKey: 'Business Unit',
    // labelKey: KEYS.businessUnit,
  },
  {
    value: 'category',
    labelKey: 'Category',
    // labelKey: KEYS.category,
  },
  {
    value: 'businessFocus',
    labelKey: 'Business Focus',
  },
  {
    value: 'activityType',
    labelKey: 'Activity Type',
    // labelKey: KEYS.activityType,
  },
  {
    value: 'timeframe',
    labelKey: 'Timeframe',
    // labelKey: KEYS.timeframe,
  },
]
